import React from 'react';

export const QueenslandInfo = () => (
    <div>
        <p className="eds-text-bl eds-l-mar-bot-4">
            Queensland State Information
        </p>
        <p className="eds-text-bm">
            $500 million loan facility, interest free for the first 12 months
        </p>
        <br />
        <p>
            <strong>How to apply:</strong>
        </p>
        <p>
            Payroll tax deferral is expected to be made available at
            www.osr.qld.gov.au by 20 March 2020.
        </p>
        <p>
            To register interest: Email us with your full name, phone number and
            preferred email address or freecall 1800 623 946. QRIDA will contact
            you when the scheme is open to applications shortly.
        </p>
        <br />
        <p>
            <strong>Links:</strong>
        </p>
        <ul>
            <li>
                <a
                    href="http://www.qrida.qld.gov.au/current-programs/covid-19-business-support/queensland-covid19-jobs-support-scheme"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Queensland COVID-19 Jobs Support Loans
                </a>
            </li>
        </ul>
    </div>
);

export const NewSouthWalesInfo = () => (
    <div>
        <p className="eds-text-bl eds-l-mar-bot-4">
            New South Wales State Information
        </p>
        <p className="eds-text-bm">
            $2.3 billion health boost and economic stimulus: $700 million in
            extra health funding and $1.6 billion in tax cuts to support jobs
        </p>
        <br />
        <p>
            <strong>Details:</strong>
        </p>
        <ul>
            <li>
                $450 million for the waiver of payroll tax for eligible
                businesses
            </li>
            <li>
                $56 million to bring forward the next round of payroll tax cuts
                by raising the threshold limit to $1 million in 2020-21
            </li>
            <li>
                $80 million to waive a range of fees & charges for small
                businesses
            </li>
            <li>
                $250 million to employ additional cleaners of public
                infrastructure
            </li>
            <li>
                More than $250 million to bring forward maintenance on public
                assets including social housing and crown land fencing
            </li>
            <li>$500 million to bring forward capital works & maintenance.</li>
        </ul>
        <br />
        <p>
            <strong>Links:</strong>
        </p>
        <ul>
            <li>
                <a
                    href="https://www.nsw.gov.au/news-and-events/news/health-boost-and-economic-stimulus/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    $2.3 billion health boost and economic stimulus
                </a>
            </li>
        </ul>
        <br />
        <p>
            To check if your business is eligible for payroll tax relief, visit:
            <br />
            <a href="https://www.revenue.nsw.gov.au/taxes-duties-levies-royalties/payroll-tax">
                Government economic stimulus announcement in response to
                COVID-19
            </a>
        </p>
    </div>
);

export const TasmaniaInfo = () => (
    <div>
        <p className="eds-text-bl eds-l-mar-bot-4">
            Tasmania State Information
        </p>
        <p className="eds-text-bm">$420 million stimulus package</p>
        <br />
        <p>
            <strong>Measures include:</strong>
        </p>
        <ul>
            <li>
                Payroll tax waivers for the last four months of this financial
                year for hospitality, tourism, seafood and exports sectors
                (other businesses with payrolls of up to $5 million will be able
                to apply, based on the impact of virus, to have their payroll
                tax waived for April to June 2020)
            </li>
            <li>
                $20m in interest-free loans to the hospitality, tourism, seafood
                and exports sectors to purchase equipment or restructuring
                business operations interest-free for 3 years.
            </li>
            <li>
                $50m in interest-free loans for local governments to upgrade,
                renovate & to do necessary maintenance
            </li>
            <li>$50m in maintenance on public buildings</li>
        </ul>
        <br />
        <p>
            <strong>Links:</strong>
        </p>
        <ul>
            <li>
                <a
                    href="http://premier-dev.dpac.tas.gov.au/documents/FACT_SHEETS_-_STIMULUS_PACKAGES_Final-V2.0.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Tasmanian Support & Stimulus Package
                </a>
            </li>
        </ul>
        <br />
        <p>
            For information and support for your business, call the Business
            Tasmania Hotline: 1800 440 026; Email: ask@business.tas.gov.au
        </p>
    </div>
);

export const WesternAustraliaInfo = () => (
    <div>
        <p className="eds-text-bl eds-l-mar-bot-4">
            Western Australia State Information
        </p>
        <p className="eds-text-bm">
            $607 million stimulus package for WA households & small businesses
        </p>
        <br />
        <p>
            <strong>Measures include:</strong>
        </p>
        <ul>
            <li>
                $402 million to freeze household fees and charges until at least
                July 1, 2021
            </li>
            <li>
                Energy Assistance Payment (EAP) doubled to $600 for vulnerable
                Western Australians, including pensioners
            </li>
            <li>
                $114 million in additional measures for small businesses; small
                businesses that pay payroll tax will receive a one-off grant of
                $17,500
            </li>
            <li>
                $1 million payroll tax threshold brought forward by 6 months to
                July 1, 2020
            </li>
            <li>Affected businesses can defer payroll tax payments</li>
            <li>
                Building on $760 million announced in the past few months to
                stimulate economy
            </li>
        </ul>
        <br />
        <p>
            <strong>How to apply:</strong>
        </p>
        <p>
            Apply to defer lodgment and payment of payroll tax returns if your
            business has been directly or indirectly impacted by COVID-19.
            Submit the application form via a web enquiry. Application form on
            the next column, web enquiry on column G.
        </p>
        <a
            href="https://www.wa.gov.au/sites/default/files/2020-03/Payroll-form-defer-payment-covid19.pdf"
            target="_blank"
            rel="noopener noreferrer"
        >
            APPLICATION TO DEFER PAYROLL TAX – COVID-19
        </a>
        <br />
        <br />
        <p>
            <strong>Links:</strong>
        </p>
        <ul>
            <li>
                <a
                    href="https://www.mediastatements.wa.gov.au/Pages/McGowan/2020/03/COVID-19-economic-response-Relief-for-businesses-and-households.aspx"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    COVID-19 economic response: Relief for businesses and
                    households
                </a>
            </li>
        </ul>
    </div>
);
